'use client'

import { useEffect, useState } from 'react'
import PageLoadEvent from '@components/HomePage/utils/pageLoadEvent'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'

const NewBlogPageLoadEvent = ({ contentfulTagNames }: { contentfulTagNames?: string }) => {
  const [properties, setProperties] = useState<object | null>(null)

  useEffect(() => {
    void segmentEventCommonPropFunc({ contentfulTagNames }).then(setProperties)
  }, [])

  if (!properties) return null

  return <PageLoadEvent viewEventName="view_seo_page" properties={properties} />
}

export default NewBlogPageLoadEvent
